<div class="page-container">
    <div class="header">
        <a routerLink="/login">
          <img src="/assets/img/3ddv/3ddv_vw_black.png" alt="Venue Workspace Logo">
        </a>
    </div>
    <div class="body">
        <p class="title">OOPS...</p>
        <p class="title">AN ERROR OCCURED</p>
        <p class="subtitle mt-4">Please contact <a>vw-support@3ddigitalvenue.com</a> for support.</p>
        <div class="d-flex justify-content-center mt-5">
            <img class="err-icon" src="/assets/img/error-icon.svg" alt="Error Icon">
        </div>
    </div>
</div>
